import { gql } from "@apollo/client"

export const EDIT_BULK_OFFBOARDING_QUERY = gql`
  query EditBulkOffboardingQuery($bulkOffboardingId: ID!) {
    bulkOffboarding(bulkOffboardingId: $bulkOffboardingId) {
      id
      company {
        name
        id
      }
      terminations {
        id
        proposedDate
        reason
        communicatedWithEmployee
        primaryCategory {
          id
        }
        secondaryCategory {
          id
        }
        intendedDaysOff
        ptoAccurate
        ptoInaccurateNote
        ptoInfo {
          daysRemaining
          daysTaken
          daysApproved
          leaveYear
          timeOffManagementEnabled
        }
        notes
        onLeave
        engagement {
          id
          name
        }
        documents {
          id
          title
          date
          tags
          filename
          createdAt
          description
        }
        additionalTerminationPayments {
          id
          amount
          currency
          amountAsPercentage
          paymentFrequency
          details
          numRecurringPayments
          amountType
          offboardingPayType {
            id
          }
        }
      }
      includesAllEngagedTeamMembers
    }
  }
`
